import { Box, Typography } from '@mui/material';

import { latestProduct } from '../../Data/StoreData';
import ProductCard from '../Card/ProductCard';
import { IStockItem, LatestProductItem } from '../../Interface/Product.interface';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../App/store';
import { useEffect } from 'react';
import { fetchStockItems } from '../../Action';
import ProductCardSkeleton from '../Skeleton/Productcardskeleton';
import { useNavigate } from 'react-router-dom';

// Renamed type from Product to LatestProductItem


const LatestProducts: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { stockItems, loading, error } = useSelector((state: RootState) => state.pos)
  

  useEffect(() => {
    dispatch(fetchStockItems())
  }, [dispatch])


  return (
    <Box sx={{ width: 300, p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Latest Products
      </Typography>
      {
        loading ? (
          Array.from({ length: 6 }).map((_, i) => <ProductCardSkeleton key={i} />)
        ) : (
          stockItems.slice(-5).map((product: IStockItem, index: number) => (
            <ProductCard
              key={index}
              image={product?.FilePath}
              name={product.itemname}
              price={product.BTCSellingRate}
              mrp={product.Mrprate}
      
            />
          )))}
    </Box>
  );
};

export default LatestProducts;
